
import Notify from './common/notify'
import VFocus from './common/v-focus'

export default {
  install(Vue, options) {

    Vue.use(Notify)
    Vue.use(VFocus)

  },
}
